// eslint-disable-next-line strict
module.exports = require('form-data');



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/classes/FormData.js
// module id = 768
// module chunks = 0